import {Component, Input, OnInit} from '@angular/core';
import {Dossiers} from '../../../common/services';
import {DarDossiersService} from '../../../common/services/dossiers/dossiers.service';
import {RecrutementTypeEnum} from '../../../common/services/enums/recrutementTypeEnum';
import {RemunerationEnum} from '../../../common/services/enums/remunerationEnum';
import {rolesDar} from '../../../common/services/roles/roles-dar';
import {DomSanitizer} from '@angular/platform-browser';
import {NewlinePipe, SafeHtmlPipe} from '@Common/widgets/pipes';

@Component({
  selector: 'app-section-dipefas',
  templateUrl: './section-dipefas.component.html',
  styleUrls: ['./section-dipefas.component.scss']
})
export class SectionDipefasComponent implements OnInit {
  @Input() dossier: Dossiers;

  remunerationEnum = RemunerationEnum;
  avisDossier: Map<string, string[]> = new Map<string, string[]>();
  AVIS_MS_KEY = 'avis_ms';
  AVIS_SBTCP_KEY = 'avis_sbtcp';
  AVIS_DRH_KEY = 'avis_drh';
  BLOCK_STYLE = 'text-align: justify; font-size: 0.8em; border: 1px solid gray; padding: 2px 2px 2px 2px;';
  constructor(public sanitizer: DomSanitizer,
              public dossierService: DarDossiersService) { }

  ngOnInit() {
  }

  getStatusLabel() {
    return this.dossier.state_title;
  }
  getDecisionCommission() {
    return `${this.dossierService.getDecision(this.dossier)}`;
  }
  getPlafondEmploi(dossier: Dossiers) {
    const plafond = this.dossierService.getPlafondsEmploi().find(_list => _list.id === dossier.plafond_emploi);
    if (plafond) {
      return plafond.label;
    }
    return '/';
  }
  getRecrutementType() {
    if (this.dossier.recrutement_type) {
      switch (this.dossier.recrutement_type) {
        case RecrutementTypeEnum.sans_publication:
          return 'Sans publication';
        case RecrutementTypeEnum.interne:
          return 'Interne';
        case RecrutementTypeEnum.externe:
          return 'Externe';
        case RecrutementTypeEnum.interne_externe:
          return 'Interne / Externe';
      }
    }
    return '';
  }

  canSeeCommission() {
    return this.dossierService.statesGtDrh.some(_state => _state === this.dossier.state);
  }

  getAvisLabel(key: string) {
    switch (key) {
      case this.AVIS_MS_KEY:
        return 'Avis MS';
      case this.AVIS_SBTCP_KEY:
        return 'Avis SBTCP';
      case this.AVIS_DRH_KEY:
        return 'Avis DRH';
    }
    return '';
  }
  getCommentaire(commentaire) {
    if (commentaire) {
      const nl: NewlinePipe = new NewlinePipe();
      const sp: SafeHtmlPipe = new SafeHtmlPipe(this.sanitizer);
      return sp.transform(`<p style="${this.BLOCK_STYLE}">${nl.transform(commentaire)}</p>`);
    }
    return '';
  }
  getAvisOuiNon(avis: string | boolean) {
    const sp: SafeHtmlPipe = new SafeHtmlPipe(this.sanitizer);
    switch (avis) {
      default:
      case null:
      case undefined:
        return '/';
      case true:
        return sp.transform(`<span style="color: green; font-weight: bold;">Oui</span>`);
      case false:
        return sp.transform(`<span style="color: red; font-weight: bold;">Non</span>`);
    }
  }
  setAvis(avis_key, commentaire_key) {
    const avis_values = [];
    const avis_decision = this.dossier[avis_key];
    avis_values.push(avis_decision);
    if (this.dossier[commentaire_key]) {
      avis_values.push(this.dossier[commentaire_key]);
    }
    this.avisDossier.set(avis_key, avis_values);
  }
  /**
   * Obtient les différents avis pour affichage
   */
  getAvis(): Map<string, string[]> {
    this.avisDossier.clear();
    if (this.dossier) {
      this.setAvis(this.AVIS_MS_KEY, 'commentaire_avis_ms');
      this.setAvis(this.AVIS_SBTCP_KEY, 'commentaire_avis_sbtcp');
      this.setAvis(this.AVIS_DRH_KEY, 'commentaire_avis_drh');
    }
    return this.avisDossier;
  }
}
